import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

const Hero = ({
  kicker,
  headingLead,
  headingTrail,
  highlight,
  description,
  primaryAction,
  secondaryAction,
  image,
  weeklyPick,
  weeklyPickLabel,
}) => {
  const { t } = useLanguage();
  const resolvedWeeklyPickLabel = weeklyPickLabel ?? t.hero.weeklyPickLabel;

  return (
    <header className="hero-shell">
      <div className="hero-grid">
        <div className="hero-copy">
          <h1 className="hero-title">
            {headingLead}
            <br />
            <span className="hero-highlight">{highlight}</span> {headingTrail}
          </h1>
          <p className="hero-description">{description}</p>
      
        </div>
        <div className="hero-visual">
          <figure className="hero-image-card">
            <img src={image.src} alt={image.alt} />
          </figure>
          <div className="weekly-pick" aria-hidden="true">
            <p className="weekly-label">{resolvedWeeklyPickLabel}</p>
            <p className="weekly-title">{weeklyPick}</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Hero;
